
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's37a9e8aec5713460': `Подробнее`,
's48413f5f20d56eac': `2) Нажать "На экран «Домой»"`,
's6196153c4b0c1ea0': `Установить`,
's8d0173763d91830c': `Этот веб-сайт имеет функционал приложения. Добавьте его на экран «Домой», чтобы получить дополнительные возможности и удобство использования.`,
's9c30494cee3b81dd': `1) Нажать "Поделиться"`,
'sa5ef80b4bb9b39f8': `Свернуть`,
'sc79fd7641eb9a975': `Спрятать Инструкцию`,
'scdaf4bbff76674c8': `На экран «Домой»`,
'sdca23702207fba73': `Этот веб-сайт имеет функционал приложения. Установите его, чтобы получить дополнительные возможности и удобство использования.`,
    };
  